/**
 * The language switch (doc/20261023-i18n-zh-cn.md §3.4; card X-16): an icon button whose menu names each language in
 * its own script, with a bilingual accessible name that never changes.
 */
import { CheckOutlined, TranslationOutlined } from '@ant-design/icons';
import { Button, Dropdown, type MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDisplayLanguage } from './displayLanguage';

/** `plain` matches the landing page's own icon buttons; otherwise an antd text button, like the console's ThemeButton. */
export function LanguageSwitch({ className, plain = false }: { readonly className: string; readonly plain?: boolean }) {
  const { t } = useTranslation();
  const { language, languages, choose } = useDisplayLanguage();
  const label = t('language.menuLabel');
  const items: MenuProps['items'] = languages.map((option) => ({
    key: option.id,
    label: <span className="lx-lang-item" lang={option.id}>
      <span className="lx-lang-tick" aria-hidden="true">{option.id === language ? <CheckOutlined /> : null}</span>
      {option.nativeName}
    </span>,
    onClick: () => choose(option.id),
  }));
  return (
    <Dropdown menu={{ items, selectedKeys: [language] }} trigger={['click']} placement="bottomRight">
      {plain
        ? <button type="button" className={className} aria-label={label} title={label} aria-haspopup="menu"><TranslationOutlined /></button>
        : <Button type="text" className={className} icon={<TranslationOutlined />} aria-label={label} title={label} aria-haspopup="menu" />}
    </Dropdown>
  );
}
